import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { PresetGrid } from "../components/PresetGrid";
import { Stopwatch } from "../components/Stopwatch";
import { TimerBreadcrumb } from "../components/TimerBreadcrumb";
import { TimerExplainer } from "../components/TimerExplainer";

export function StopwatchPage() {
  return (
    <div className="pct-page relative min-h-screen">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-96 pct-glow" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <TimerBreadcrumb current={m.timer_nav_stopwatch()} />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.timer_stopwatch_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.timer_stopwatch_intro()}
          </p>
        </header>

        <Stopwatch />

        <TimerExplainer
          howTo={m.timer_stopwatch_howto()}
          faqs={[
            { q: m.timer_stopwatch_faq1_q(), a: m.timer_stopwatch_faq1_a() },
            { q: m.timer_stopwatch_faq2_q(), a: m.timer_stopwatch_faq2_a() },
            { q: m.timer_stopwatch_faq3_q(), a: m.timer_stopwatch_faq3_a() },
            { q: m.timer_stopwatch_faq4_q(), a: m.timer_stopwatch_faq4_a() },
          ]}
          uses={[
            m.timer_stopwatch_use1(),
            m.timer_stopwatch_use2(),
            m.timer_stopwatch_use3(),
          ]}
        />

        <AdPlacement className="mt-10" />
        <PresetGrid currentSlug="stopwatch" />
      </div>
    </div>
  );
}
